import { ForwardedRef, forwardRef, ReactElement } from 'react';
import { Info, Check, TriangleAlert, X } from 'lucide-react';
import { TagWrapper } from './TagWrapper';
import type { TagProps, IconTagVariant } from './types';

const tagIcons: Record<IconTagVariant, ReactElement> = {
  success: <Check size={20} className='eye:text-green-100' aria-hidden />,
  hint: <Info size={20} className='eye:text-blue-150' aria-hidden />,
  warning: (
    <TriangleAlert size={20} className='eye:text-olive-100' aria-hidden />
  ),
  error: <X size={20} className='eye:text-red-100' aria-hidden />,
};

export const Tag = forwardRef(function (
  { children, ...props }: TagProps,
  ref: ForwardedRef<HTMLDivElement>,
) {
  return (
    <TagWrapper ref={ref} {...props}>
      {tagIcons[props.variant as IconTagVariant]}
      {children}
    </TagWrapper>
  );
});

Tag.displayName = 'Tag';
